import React, { useState } from 'react';
import { AppBar, IconButton, Toolbar, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from '../sidebar/sidebar';
import LogoutIcon from '@mui/icons-material/Logout';

const Layout = ({ children, signOut, user }) => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const navigate = useNavigate();  
  const handleToggleSidebar = () => {
    setOpenSidebar(!openSidebar);
  };

  return (
    <div style={{ display: 'flex' }} sx={{ flexGrow: 1, zIndex:2, }}>
      <AppBar sx={{
        backgroundColor: "#0F385C",
        backgroundSize: "40px 40px",
        zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ display: "flex", width: "100%" }}>

          
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleToggleSidebar}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          <Grid 
          container direction="row" 
          alignItems="center" spacing={2}
          justifyContent={'space-between'}
          sx={{ flexGrow: 1 ,padding: 1,
            flexDirection: { xs: "column", md: "row" },
            zindex: 1}}
          >
            <Grid item xs={12} sm={6} md = {6}sx={{padding: '5px 10px'}} >
              <Typography 
                variant="h6" 
                onClick={() => navigate('/')}
                sx={{ 
                  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                  fontSize: 'xx-large',
                  cursor: "pointer",  
                  color: "white"
                }}
              >
                GEMMA Console         
              </Typography>
           </Grid>
            {/* <Grid item xs={12} sm={3} md={3}
            sx={{ textAlign: { xs: 'center', sm: 'center' }, 
            padding: '5px 10px' }}>
              <Typography
                variant="h7"
                sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: 'small', sm: 'large' }, // Make font size responsive
                  padding: '5px 10px',
                  border: '1px solid cyan',
                  borderRadius: '5px',
                  color: 'white',
                  wordBreak: 'break-word', // Allow word wrapping on smaller screens
                  whiteSpace: 'normal', // Allow text to wrap
                }}
              >
                10 year emissions change (2022-2012): −20%
              </Typography>
              </Grid> */}
              <Grid item xs={12} sm={3} md={3}
            sx={{ justifySelf: "flex-end", 
            ml: 'auto',
            textAlign: { xs: 'right', sm: 'right' }, 
            marginLeft: '10px',
            padding: '5px 10px',
             }}>
              <Button className="signout-button"
              sx={{paddingLeft:'10px', marginLeft:'10px', textAlign:'right',
              background: '#1D70B8',
              fontWeight: 'bold',
              fontSize: { xs: 'small'},
              border: '1px solid #8EB8DC',
              color:'#FFFFFF'}} 
              onClick={signOut} variant="contained" endIcon={<LogoutIcon />}> 
                Sign Out
              </Button>
              </Grid>
              
            
          </Grid>
        </Toolbar>
      </AppBar>

      <div id="sidebar">
        <Sidebar open={openSidebar} onClose={handleToggleSidebar} />
      </div>

      <div style={{ transition: 'margin 0.2s', flex: 1 }}>{children}</div>
    </div>
  );
};

export default Layout;
